export default "__VITE_ASSET__DoIqNDCs__ 1920w";